export default __webpack_public_path__ + "static/undp-the-climate-dictionary-v2-f4b363183bff8a7f62007648f11ff36e.pdf";